import { render, staticRenderFns } from "./OrthoPlayControls.vue?vue&type=template&id=a15f401c&scoped=true&"
import script from "./OrthoPlayControls.vue?vue&type=script&lang=js&"
export * from "./OrthoPlayControls.vue?vue&type=script&lang=js&"
import style0 from "./OrthoPlayControls.vue?vue&type=style&index=0&id=a15f401c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15f401c",
  null
  
)

export default component.exports